<div class="wiz-component-container" width="100%" [ngClass]="{'disabled-class': wizDisabled}">
  <div class="wiz-component-label" width="100%" *ngIf="wizShowLabel">
    <wiz-label id="label" #innerLabel [wizLabel]="wizLabel" [wizTextBehavior]="'truncate'"
    [ngClass]="{'error-class': hasErrors}"></wiz-label><!-- label -->
    <span #innerAsterisk *ngIf="wizMandatory" class='mandatory-class'>*</span><!-- asterisque -->
  </div>

  <!-- zone de saisie -->
  <div id="inzone" width="100%" class="wiz-component-field innerfocus-class"
  [ngClass]="{'error-class': hasErrors}"
  >

    <!-- icone de gauche -->
    <mat-icon  #innerLeftIcon wizNotFocusable *ngIf="wizLeftIcon"
    (click)="wizOnLeftIconClicked()" class="innerIcon">
      <wiz-icon class="smallMe">{{wizLeftIcon}}</wiz-icon>
    <!-- {{wizLeftIcon}} -->
  </mat-icon>

    <input #innerInput
      [maxlength]="wizMaxChars"
      [type]="innerInputType"
      width="100%"
      [ngModel]="getInnerInputValue()"
      [disabled]="wizDisabled"
      [placeholder]="translatedPlaceholder"
      class="wiz-input"
      (ngModelChange)="onChange($event)"
      (focus)="onFocus($event)"
      (click)="inputClic($event)"
      (blur)="onBlur($event)"
      autocomplete="off"
      [readonly]="readonly"
      [tabIndex]="wizTabIndex"/>

    <!-- bouton "clear" -->
    <!-- wizNotFocusable utilisé pour éviter la perte de focus au niveau du dom  -->
    <mat-icon #innerClearIcon wizNotFocusable  *ngIf="showClearIcon()" (click)="onClear($event)" class="innerIcon">close</mat-icon>

    <!-- bouton de droite -->
    <!-- wizNotFocusable utilisé pour éviter la perte de focus au niveau du dom  -->
    <mat-icon #innerRightIcon wizNotFocusable *ngIf="wizRightIcon" (click)="wizOnRightIconClicked()" class="innerIcon">
      <!-- {{wizRightIcon}} -->
      <wiz-icon class="smallMe">{{wizRightIcon}}</wiz-icon>
    </mat-icon>

    <!-- bouton showPassword -->
    <!-- wizNotFocusable utilisé pour éviter la perte de focus au niveau du dom  -->
    <mat-icon #innerPasswordIcon wizNotFocusable *ngIf="showPasswordIcon" (click)="switchPasswordType()" class="innerIcon">
      <!-- {{passwordIcon}} -->
      <wiz-icon class="smallMe">{{passwordIcon}}</wiz-icon>
    </mat-icon>
  </div>

  <div class="wiz-component-hint wiz-component-label" width="100%">
    <!-- le hint -->
    <wiz-label #innerhint class="hint-class" *ngIf="wizHint" [wizLabel]="wizHint"></wiz-label>
    <!-- l'affichage de l'erreur -->
    <ng-container #errorContainer id="error"></ng-container>
  </div>
</div>

